import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

// Bare client for PUBLIC (unauthenticated) endpoints — never sends Authorization,
// so browsers treat it as a simple request (no CORS preflight).
export const publicApi = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("bides_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export function apiError(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Something went wrong.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return String(d);
}

export default api;

export async function openPdf(path, download, filename) {
  const r = await api.get(path, { responseType: "blob" });
  const url = URL.createObjectURL(r.data);
  const a = document.createElement("a");
  a.href = url;
  if (download) a.download = filename || path.split("/").pop();
  else a.target = "_blank";
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 4000);
}

// Build a URL for an uploaded file stored in object storage.
// Passes JWT via query param so <img>/links work. Returns data:/http:/blob: sources as-is.
export const fileUrl = (src) => {
  if (!src) return "";
  if (/^(data:|https?:|blob:)/.test(src)) return src;
  const t = localStorage.getItem("bides_token");
  return `${API}/files/${src}${t ? `?auth=${t}` : ""}`;
};

// Public (unauthenticated) file URL — only branding assets are served publicly.
export const publicFileUrl = (src, v) => {
  if (!src) return "";
  if (/^(data:|https?:)/.test(src)) return src;
  return `${API}/public-files/${src}${v ? `?v=${v}` : ""}`;
};
